import React , { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import MaterialTable, { MaterialTableProps } from 'material-table';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation } from 'react-router-dom';
import { initQueryParams, replaceHistory, tableOptions, useQuery } from '../../../shared/lib/TableQueryParams';
import { PaginatedResponse } from '../../../shared/models';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG } from '../../../shared/lib/Localization';
import { ProductsWithMarginLessThanZero } from '../../models';
import { getProductsWithMarginLessThanZero } from '../../api';

import {
    CustomTableTitle,
    ErrorStatusBar,
    ExportMenu,
    ExportStatusBar,
} from '../../../shared/components';
import download from 'downloadjs';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
       
    }),
);

const ProductsWithMarginLessThanZeroScreen = (props: any) => {
    const classes = useStyles({});
    const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
    const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
    const tableRef = useRef<{ onQueryChange: any; }>();
    let locationQuery = useQuery(useLocation);
    const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
    const [exportBtnAnchorEl, setExportBtnAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isExporting, setExporting] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [initialLoad,setInitialLoad]=useState(true);

    useEffect(() => {
        if(!isLoading && !initialLoad){
        tableRef && tableRef.current && tableRef.current.onQueryChange();
        }
    }, [props.userData.selectedBusiness]);

    const exportCSV = () => {
        if (props.userData && props.userData.selectedBusiness) {
            setExporting(true);
            const sb = props.userData.selectedBusiness;
            const shouldExport = true;
            const currentSearch = locationQuery.get('search') || tableQuery.search || '';
            getProductsWithMarginLessThanZero(
                sb.business_id,
                null,
                null,
                currentSearch,
                sb.orderBy,
                null,
                shouldExport
            )
                .catch(handleError) // handle network issues
                .then(checkStatus)
                .then((res) => res.blob())
                .then((data) => {
                    download(data, 'Products_with_margin_less_than_zero.csv', 'text/csv');
                    setExporting(false);
                    setInitialLoad(false);
                })
                .catch((error: any) => {
                    setExporting(false);
                    if (error) {
                        if (error.status && error.status === 500) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                        } else if (error.status === 403 || error.status === 401) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(true);
                        } else {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                        }
                    }
                });
        }
    };


    const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setExportBtnAnchorEl(event.currentTarget);
    };


    const handleExportMenuClose = (shouldExport: boolean) => {
        if (shouldExport) {
            exportCSV();
        }
        setExportBtnAnchorEl(null);
    };


    return (
        <Container maxWidth={false}>
            <ErrorStatusBar isVisible={isErrorStatusVisible} />
            <ExportStatusBar isVisible={isExporting} />

            <div className="table-wrapper">
                <MaterialTable
                    options={{ 
                        ...tableOptions(tableQuery),
                        thirdSortClick: false,
                        draggable: false,
                        sorting: true
                    }}
                    tableRef={tableRef}
                    localization={{
                        body: {
                            emptyDataSourceMessage: emptyDataSourceMessage
                        }
                    }}
                    columns= {[
                        { title: 'Product', field: 'product_name' },
                        {title:'Dated Price', field:'dated_price'},
                        { title: 'Purchase Price', field: 'purchase_price_converted' },
                        { title: 'Margin', field: 'margin' },

                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            replaceHistory(query, props.history);
                            let pageData = {
                                data: [] as ProductsWithMarginLessThanZero[],
                                totalCount: 0,
                                page: query.page
                            };
                            if (props.userData && props.userData.selectedBusiness){
                                const sb = props.userData.selectedBusiness;
                                let orderBy = '';
                                if (query.orderBy) {
                                    orderBy = query.orderBy.field as string;
                                    orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                                }
                                getProductsWithMarginLessThanZero(
                                    sb.business_id,
                                    query.page + 1,
                                    query.pageSize,
                                    query.search,
                                    orderBy,
                                    null,
                                    false
                                )
                                    .catch(handleError) // handle network issues
                                    .then(checkStatus)
                                    .then(parseJSON)
                                    .then((data: PaginatedResponse<any>) => {
                                        setErrorStatusVisible(false);
                                        setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                                        pageData = {
                                            data: data.results,                                            
                                            totalCount: data.count,
                                            page: query.page
                                        };
                                       
                                        setTableQuery({
                                            ...tableQuery,
                                            search: query.search,
                                            orderBy,
                                            totalCount: data.count,
                                            page: query.page,
                                            pageSize: query.pageSize
                                        });
                                        // console.log(pageData.data)
                                        resolve(pageData);
                                        setInitialLoad(false);
                                        // console.log(pageData.data)
                                    })
                                    .catch((error: any) => {
                                        if (error) {
                                            if (error.status && error.status === 500) {
                                                setEmptyDataSourceMessage(ERROR_500);
                                                setErrorStatusVisible(false);
                                            } else if ((error.status === 403 || error.status === 401)
                                            ) {
                                                setEmptyDataSourceMessage(ERROR_MSG);
                                                setErrorStatusVisible(true);
                                            } else {
                                                setEmptyDataSourceMessage(ERROR_MSG);
                                                setErrorStatusVisible(false);
                                            }
                                        }
                                        setTableQuery({
                                            ...tableQuery,
                                            search: query.search,
                                            totalCount: 0,  
                                            page: query.page,
                                            pageSize: query.pageSize
                                        });
                                        resolve(pageData);
                                    });
                            }
                        })
                    }
                    title={
                        <CustomTableTitle
                            history={props.history}
                            title={'Products With Margin Less Than Zero'}
                            icon={SVG_ICONS.product} />
                    }
                    actions={[
                        {
                            icon: 'save_alt',
                            tooltip: 'Export',
                            isFreeAction: true,
                            onClick: handleExportClick,
                            disabled: isExporting,
                        },
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                    ]}
                />
                <ExportMenu anchorEl={exportBtnAnchorEl} handleClose={handleExportMenuClose} />

            </div>
        </Container>
    );
};


const mapStateToProps = (state: any) => {
  return {
      userData: state.userLocalData,
  };
};


export default connect(mapStateToProps, null)(ProductsWithMarginLessThanZeroScreen);






    

